import React, {Suspense, useEffect, useLayoutEffect} from 'react';
import TagManager from 'react-gtm-module';
import './App.css';
import {Routes, Route, Navigate, useLocation} from 'react-router-dom';
import AuthProvider from './components/authprovider';
import DefaultLayout from './components/layout/defaultlayout';
import AsyncHome from './pages/home/async';
import AsyncProduct from './pages/product/async';
import {useTranslation} from 'react-i18next';
import pathUtils from './utils/pathUtils';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/styles/base.css';

export const pageTypes = {eyewear: 'EYEWEAR', makeup: 'MAKEUP'};
export default function App() {
  const {i18n} = useTranslation();
  const location = useLocation();

  useLayoutEffect(() => {
    const language = pathUtils.getLangFromPathname(location.pathname);
    i18n.changeLanguage(language);
  }, [location.pathname]);

  useEffect(() => {
    window.ymkAsyncInit = () => {
      TagManager.initialize({gtmId: 'GTM-K6L9D76'});
    };
  }, []);

  return (
    <Suspense fallback={<div />}>
      <AuthProvider>
        <Routes>
          {pathUtils.getAllLangPrefixes().map((prefix) => (
            <Route key={prefix} path={`/${prefix}/business/showcase/online-service`} element={<DefaultLayout />}>
              <Route path="" element={<AsyncHome pageType={pageTypes.makeup} />} />
              <Route path="eye-wear" element={<AsyncHome pageType={pageTypes.eyewear} />} />
              <Route path="product/:productId" element={<AsyncProduct pageType={pageTypes.makeup} />} />
              <Route path="eye-wear/product/:productId" element={<AsyncProduct pageType={pageTypes.eyewear} />} />
              <Route path="*" element={<Navigate to="" replace />} />
            </Route>
          ))}
        </Routes>
      </AuthProvider>
    </Suspense>
  );
}
